import { render } from "./premium-actions.vue?vue&type=template&id=19409467&lang=pug"
import script from "./premium-actions.vue?vue&type=script&lang=js"
export * from "./premium-actions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__